import { ViewType } from '../modules/core/graphql/types';

export const EXCLUDED_VIEW_TYPES: { [key in ViewType]: boolean } = {
  [ViewType.FORM]: true,
  [ViewType.GALLERY]: false,
  [ViewType.GRID]: false,
  [ViewType.KANBAN]: false,
};
